<script>
import axios from "axios";
import Layout from "../../layouts/auth";
import { authMethods } from "@/state/helpers";
import appConfig from "@/app.config";

import { required, email, sameAs, minLength, maxLength } from "vuelidate/lib/validators";

/**
 * Forgot Password component
 */
export default {
  page: {
    title: "Forgot Password",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      email: "",
      otp: "",
      newPassword: "",
      confirmPassword: "",
      countDown: 30,
      submitted: false,
      submittedOTP: false,
      submittedReset: false,
      error: null,
      tryingToReset: false,
      isResetError: false,
      resetErrorMsg: false,
      otpLoader: false,
      status : 0,
      showNewPassword: false,
      isResendOtpDisabled: false,
      isResetSuccess: false,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    otp: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(6),
    },
    newPassword: {
      required,
    },
    confirmPassword: {
      required,
      sameAsPassword: sameAs('newPassword')
    },
  },
  methods: {
    ...authMethods,
    // Try to register the user in with the email, fullname
    // and password they provided.
    tryToReset() {
      this.submitted = true;
      this.otpLoader = true;
      // stop here if form is invalid
      this.$v.email.$touch();
      
    
      if (this.$v.email.$invalid) {
        this.otpLoader = false;
        return;
      } else {
        let formData = new FormData();
        formData.append("email", this.email);
        axios
            .post(process.env.VUE_APP_EMPLOYEE_URL + `/account/send_otp`, formData)
            .then((res) => {
              if(res.data.success == "true") {
                this.isResendOtpDisabled = true;
                this.countDownTimer();
                setTimeout(() => {
                  this.isResendOtpDisabled = false;
                }, 30000);
                this.status = 1;
              } else {
                this.isResetError = true;
                this.resetErrorMsg = res.data;
              }
              return res;
            })
            .catch((err) => {
              this.isResetError = true;
                this.resetErrorMsg = "Oops! Some Error Occured.";
              return err;
            });
        }
      
      // code
      /* else {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          this.tryingToReset = true;
          // Reset the authError if it existed.
          this.error = null;
          return (
            this.resetPassword({
              email: this.email,
            })
              // eslint-disable-next-line no-unused-vars
              .then((token) => {
                this.tryingToReset = false;
                this.isResetError = false;
              })
              .catch((error) => {
                this.tryingToReset = false;
                this.error = error ? error : "";
                this.isResetError = true;
              })
          );
        } else if (process.env.VUE_APP_DEFAULT_AUTH === "authapi") {
          axios
            .post("http://127.0.0.1:8000/api/password/create", {
              email: this.email,
            })
            .then((res) => {
              this.isResetError = true;
              this.error = res.data;
              return res;
            });
        }
      } */
      this.otpLoader = false;
      this.submitted = false;
    },
    countDownTimer () {
      if (this.countDown > 0) {
        setTimeout(() => {
            this.countDown -= 1
            this.countDownTimer()
        }, 1000)
      } else {
        this.countDown = 10;
      }
    },
    verifyOTP() {
      this.submittedOTP = true;
      this.otpLoader = true;
      this.$v.otp.$touch();
      if (this.$v.otp.$invalid) {
        this.otpLoader = false;
        return;
      } else {
        let formData = new FormData();
        formData.append("email", this.email);
        formData.append("otp", this.otp);
        axios
            .post(process.env.VUE_APP_EMPLOYEE_URL + `/account/verify`, formData)
            .then((res) => {
              if(res.data.success == "true") {
                this.status = 2;
              } else {
                this.isResetError = true;
                this.resetErrorMsg = res.data;
              }
              return res;
            })
            .catch((err) => {
              this.isResetError = true;
                this.resetErrorMsg = "Oops! Some Error Occured.";
              return err;
            });
      }
      this.otpLoader = false;
      this.submittedOTP = false;
      // stop here if form is invalid
    },
    resendOTP() {

    },
    resetPassword() {
      this.submittedReset = true;
      this.otpLoader = true;
      this.$v.newPassword.$touch();
      this.$v.confirmPassword.$touch();

      if(this.$v.newPassword.$invalid || this.$v.confirmPassword.$invalid) {
        this.otpLoader = false;
        return;
      } else {
        let formData = new FormData();
        formData.append("email", this.email);
        formData.append("newPassword", this.newPassword);
        formData.append("newConfirmPassword", this.confirmPassword);
        axios
            .post(process.env.VUE_APP_EMPLOYEE_URL + `/account/reset_password`, formData)
            .then((res) => {
              if(res.data.success == "true") {
                this.isResetSuccess = true;
                setTimeout(() => {
                this.$router.push("/login");
                this.apiHit = false;
              }, 2000);
              } else {
                this.isResetError = true;
                this.resetErrorMsg = res.data;
              }
              return res;
            })
            .catch((err) => {
              this.isResetError = true;
                this.resetErrorMsg = "Oops! Some Error Occured.";
              return err;
            });
      }
      this.otpLoader = false;
      this.submittedReset = false;
    },
    showPassword() {
      this.showNewPassword = !this.showNewPassword;
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Reset Password</h5>
                  <p v-if="status == 0">Enter email to reset password.</p>
                  <p v-if="status == 1">Verify OTP.</p>
                  <p v-if="status == 2">Create New Password.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img
                  src="@/assets/images/profile-img.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo-blue.png" alt height="48" />
                  </span>
                </div>
              </router-link>
            </div>

            <div class="p-2">
              <b-alert
                v-model="isResetSuccess"
                class="mt-3"
                variant="success"
                dismissible
                >Reset Password successfull.
              </b-alert
              >
              <b-alert
                v-model="isResetError"
                class="mb-4"
                variant="danger"
                dismissible
                >{{ resetErrorMsg }}</b-alert
              >
              <form @submit.prevent="tryToReset" v-if="status == 0">
                <div class="mb-3">
                  <label for="useremail">Email</label>
                  <input
                    type="email"
                    v-model="email"
                    class="form-control"
                    id="useremail"
                    placeholder="Enter email"
                    :class="{ 'is-invalid': submitted && $v.email.$error }"
                  />
                  <div
                    v-if="submitted && $v.email.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.email.required">Email is required.</span>
                    <span v-if="!$v.email.email"
                      >Please enter valid email.</span
                    >
                  </div>
                </div>
                <div class="mb-3 row mb-0">
                  <div class="col-12 text-end">
                    <button class="btn btn-primary w-md" type="submit">
                      <b-spinner
                        v-if="otpLoader"
                        small
                        class="m-2"
                        variant="white"
                        role="status"
                      ></b-spinner><span v-else>Reset</span>
                    </button>
                  </div>
                </div>
              </form>
              <form @submit.prevent="verifyOTP" v-if="status == 1">
                <div class="mb-3">
                  <label for="otp"> Otp</label>
                  <input
                    type="text"
                    v-model="otp"
                    class="form-control"
                    id="otp"
                    placeholder="Enter otp"
                    :class="{ 'is-invalid': submittedOTP && $v.otp.$error }"
                  />
                  <div
                    v-if="submittedOTP && $v.otp.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.otp.required">OTP is required.</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 text-end">
                    <button :disabled="isResendOtpDisabled" class="btn btn-link w-md" @click="resendOTP" type="button">
                      Resend OTP
                    </button><br />
                    <span class="fs-6 text-danger" v-if="isResendOtpDisabled"> Sent Otp again in {{countDown}} Seconds.</span>
                  </div>
                   </div>
                <div class="mb-3 row mb-0">
                  <div class="col-6 mt-3">
                    <button class="btn btn-outline-secondary w-md" type="button" @click="status = 0;">
                      Edit email
                    </button>
                  </div>
                  <div class="col-6 text-end mt-3">
                    <button class="btn btn-primary w-md" type="submit">
                      <b-spinner
                        v-if="otpLoader"
                        small
                        class="m-2"
                        variant="white"
                        role="status"
                      ></b-spinner><span v-else>Verify</span>
                    </button>
                  </div>
                </div>
              </form>
              <form @submit.prevent="resetPassword" v-if="status == 2">
                <div class="mb-3">
                  <label for="newpassword">New Password</label>
                  <div class="row">
                    <div class="col-11">
                      <input
                       :type="showNewPassword == false ? `password` : `text`"
                        v-model="newPassword"
                        class="form-control"
                        id="newpassword"
                        placeholder="Enter New Password"
                        :class="{ 'is-invalid': submittedReset && $v.newPassword.$error }"
                      />
                    </div>
                    <div class="col-1">
                      <button type="button" style="margin-left: -65px" class="btn btn-secondary" @click="showPassword"><i v-if="showNewPassword == false" class="bx bx-show-alt font-size-15"></i><i v-else class="bx bxs-hide font-size-15"></i></button>
                    </div>
                  </div>
                  <div
                    v-if="submittedReset && $v.newPassword.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.newPassword.required">Password is required.</span>
                  </div>
                </div>
                <div class="col-11 mb-3">
                  <label for="newconfirmpassword">Confirm Password</label>
                  <input
                    type="password"
                    v-model="confirmPassword"
                    class="form-control"
                    id="newconfirmpassword"
                    placeholder="Enter Confirm Password"
                    :class="{ 'is-invalid': submittedReset && $v.confirmPassword.$error }"
                  />
                  <div
                    v-if="submittedReset && $v.confirmPassword.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.confirmPassword.required">Password is required.<br/></span>
                    <span v-if="!$v.confirmPassword.sameAsPassword"
                      >Passwords should match.</span
                    >
                  </div>
                </div>
                <div class="mb-3 row mb-0">
                  <div class="col-12 text-end">
                    <button class="btn btn-primary w-md" type="submit">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>
            Remember It ?
            <router-link
              to="/login"
              class="fw-medium text-primary"
              >Sign In here</router-link
            >
          </p>
          <!--<p>
            © {{ new Date().getFullYear() }} Skote. Crafted with
            <i class="mdi mdi-heart text-danger"></i> by Themesbrand
          </p>-->
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
